import Flickity from 'flickity';
import 'flickity-fade';

class MoviPro {
	$tith: Element | null = null;
	$tithNavItems!: NodeListOf<Element>;
	tithImageFlkty: Flickity | null = null;
	tithCaptionFlkty: Flickity | null = null;
	syncingTith = false;

	init() {
		this.initAutoplaySliders();
		this.cache();
		this.initTith();
	}

	cache() {
		this.$tith = document.querySelector('.mproVersatileToad');
		this.$tithNavItems = document.querySelectorAll('.mproVersatileToad .js-switch');
	}

	initAutoplaySliders() {
		document
			.querySelectorAll('.mproPowerfulScreen .slider, .mproSmartApp .slider')
			.forEach((el) => {
				new Flickity(el as HTMLElement, {
					autoPlay: 4000,
					prevNextButtons: true,
					pageDots: false,
					wrapAround: true,
					pauseAutoPlayOnHover: true,
				});
			});
	}

	initTith() {
		if (!this.$tith) {
			return;
		}

		const imageSlider = this.$tith.querySelector('.slider') as HTMLElement | null;
		const captionSlider = this.$tith.querySelector('.captions') as HTMLElement | null;
		if (!imageSlider || !captionSlider) {
			return;
		}

		const fadeOptions = {
			fade: true,
			prevNextButtons: false,
			pageDots: false,
			contain: true,
			draggable: false,
		};

		this.tithImageFlkty = new Flickity(imageSlider, fadeOptions);
		this.tithCaptionFlkty = new Flickity(captionSlider, fadeOptions);

		this.tithImageFlkty.on('select', () => {
			this.syncTithSliders(this.tithImageFlkty!, this.tithCaptionFlkty!);
			this.setActiveSwitch(this.tithImageFlkty!.selectedIndex);
		});

		this.tithCaptionFlkty.on('select', () => {
			this.syncTithSliders(this.tithCaptionFlkty!, this.tithImageFlkty!);
			this.setActiveSwitch(this.tithCaptionFlkty!.selectedIndex);
		});

		for (let i = 0; i < this.$tithNavItems.length; i++) {
			this.$tithNavItems[i].addEventListener('click', this.tithNavClick.bind(this));
		}
		this.setActiveSwitch(0);
	}

	syncTithSliders(source: Flickity, target: Flickity) {
		if (this.syncingTith || target.selectedIndex === source.selectedIndex) {
			return;
		}
		this.syncingTith = true;
		target.select(source.selectedIndex, false, true);
		this.syncingTith = false;
	}

	setActiveSwitch(index: number) {
		for (let i = 0; i < this.$tithNavItems.length; i++) {
			this.$tithNavItems[i].classList.toggle('active', i === index);
		}
	}

	tithNavClick(e: Event) {
		const target = e.currentTarget as HTMLElement;
		const to = target.getAttribute('data-slide-to');
		if (to === null || !this.tithImageFlkty || !this.tithCaptionFlkty) {
			return;
		}

		const index = Number(to);
		this.tithImageFlkty.select(index);
		this.tithCaptionFlkty.select(index);
		this.setActiveSwitch(index);
	}
}

new MoviPro().init();
